import { TextField, Checkbox, FormControlLabel, Box, Typography, Paper, Grid } from "@mui/material";
import React from "react";

import { DaySchedule } from "0.Mine/3.Interfaces/Schedule";

interface EmployeeScheduleProps {
  schedule: Record<string, DaySchedule>;
  onScheduleChange: (newSchedule: Record<string, DaySchedule>) => void;
}

export function EmployeeSchedule({ schedule, onScheduleChange }: EmployeeScheduleProps) {
  const handleDayToggle = (day: string) => {
    onScheduleChange({
      ...schedule,
      [day]: { ...schedule[day], isOpen: !schedule[day].isOpen },
    });
  };

  const handleContinuousToggle = (day: string) => {
    onScheduleChange({
      ...schedule,
      [day]: { ...schedule[day], isContinuous: !schedule[day].isContinuous },
    });
  };

  const handleTimeChange = (day: string, period: string, value: string) => {
    onScheduleChange({
      ...schedule,
      [day]: { ...schedule[day], [period]: value },
    });
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      {Object.entries(schedule).map(([day, daySchedule]) => (
        <Paper
          key={day}
          sx={{ p: 2, borderRadius: 2, bgcolor: daySchedule.isOpen ? "white" : "grey.100" }}
        >
          <FormControlLabel
            control={
              <Checkbox checked={daySchedule.isOpen} onChange={() => handleDayToggle(day)} />
            }
            label={
              <Typography variant="body1" sx={{ textTransform: "capitalize" }}>
                {day}
              </Typography>
            }
          />

          <Box sx={{ ml: 3 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={daySchedule.isContinuous}
                  onChange={() => handleContinuousToggle(day)}
                  disabled={!daySchedule.isOpen}
                />
              }
              label={<Typography variant="body2">Orario continuato</Typography>}
            />

            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="body2" fontWeight="medium" mb={1}>
                  Mattina
                </Typography>
                <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                  <TextField
                    type="time"
                    value={daySchedule.morningOpen}
                    onChange={(e) => handleTimeChange(day, "morningOpen", e.target.value)}
                    disabled={!daySchedule.isOpen}
                    size="small"
                    fullWidth
                  />
                  <Typography>-</Typography>
                  <TextField
                    type="time"
                    value={daySchedule.morningClose}
                    onChange={(e) => handleTimeChange(day, "morningClose", e.target.value)}
                    disabled={!daySchedule.isOpen || daySchedule.isContinuous}
                    size="small"
                    fullWidth
                  />
                </Box>
              </Grid>

              <Grid item xs={6}>
                <Typography variant="body2" fontWeight="medium" mb={1}>
                  Pomeriggio
                </Typography>
                <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                  <TextField
                    type="time"
                    value={daySchedule.afternoonOpen}
                    onChange={(e) => handleTimeChange(day, "afternoonOpen", e.target.value)}
                    disabled={!daySchedule.isOpen || daySchedule.isContinuous}
                    size="small"
                    fullWidth
                  />
                  <Typography>-</Typography>
                  <TextField
                    type="time"
                    value={daySchedule.afternoonClose}
                    onChange={(e) => handleTimeChange(day, "afternoonClose", e.target.value)}
                    disabled={!daySchedule.isOpen}
                    size="small"
                    fullWidth
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Paper>
      ))}
    </Box>
  );
}
